import { render, staticRenderFns } from "./metariaNewsDialog.vue?vue&type=template&id=b4c7956c&scoped=true"
import script from "./metariaNewsDialog.vue?vue&type=script&lang=js"
export * from "./metariaNewsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c7956c",
  null
  
)

export default component.exports